import React, {useEffect, useState} from "react";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS} from "../../util/Constants";
import {FormattedMessage, useIntl} from "react-intl";

function CookiesBanner() {
    const userAcceptedCookiesStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES);
    const intl = useIntl();

    const cookies = intl.formatMessage({ id: "Cookies", defaultMessage: "Cookies" }).toLowerCase();
    const [state, setState] = useState({
        cookiePopupIsVisible: false,
        cookieConfiguratorIsVisible: false,
        configuratorSwitch: true,
        cookieBlurBackgroundIsVisible: true,
        userAcceptedAllCookies: false,
    });

    useEffect(() => {
        if (!userAcceptedCookiesStorage) {
            setState({
                ...state,
                cookiePopupIsVisible: true
            })
        }
    }, []);




    const cookieMsg = (
        <FormattedMessage
            id="CookiesMessage"
            defaultMessage="CookiesMessage"
            values={{
                cookiesLink: <a className="readMoreLink" href="https://www.zoniz.com/data-privacy#cookies" target="_blank">
                    {cookies}
                </a>
            }}
        />
    );

    const toggleSwitch = () => {
        setState({
            ...state,
            configuratorSwitch: !state.configuratorSwitch
        })
    }

    const acceptAllCookies = () => {
        setState({
            ...state,
            userAcceptedAllCookies: true,
            cookieBlurBackgroundIsVisible: false,
            cookieConfiguratorIsVisible: false,
            cookiePopupIsVisible: false
        })
        StorageService.setItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES, "true");

    }

    const openConfigurator = () => {
        setState({
            ...state,
            cookieConfiguratorIsVisible: true,
        })
    }

    const closeConfigurator = () => {
        setState({
            ...state,
            cookieConfiguratorIsVisible: false,
        })
    }

    const savePreferences = () => {
        let acceptedStatistics;
        if (state.configuratorSwitch) {
            acceptedStatistics = true;
        } else {
            acceptedStatistics = false;
        }

        if (acceptedStatistics) {
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES, "true")
        } else {
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES, "false")
        }
        setState({
            ...state,
            cookieConfiguratorIsVisible: false,
            cookiePopupIsVisible: false,
            cookieBlurBackgroundIsVisible: false,
            userAcceptedAllCookies: acceptedStatistics
        })
    }




    return (
        <>
            {state.cookiePopupIsVisible ?
                <>
                    <div onClick={closeConfigurator}
                         className={state.cookieBlurBackgroundIsVisible ? "blur-element" : "blur-element hide"}></div>
                    <div className="prajitura-popup-wrapper"  data-qa="prajitura-popup-wrapper">
                        <div className="prajituraPopup">
                            <div className="message">
                                {cookieMsg}
                            </div>
                        </div>
                        <button onClick={acceptAllCookies} className="accept-all-cookies-btn neutral-btn" data-qa="prajitura-accept-all-cookies-btn"><FormattedMessage id="AcceptAll"/>
                        </button>
                        <div>
                            <button onClick={openConfigurator} id="configureCookiePrefBtn" data-qa="prajitura-customize-btn"><FormattedMessage id="Customize"/></button>
                        </div>
                    </div>

                    <div
                        className={state.cookieConfiguratorIsVisible ? "prajitura-configurator" : "prajitura-configurator hide"}  data-qa="prajitura-configurator">
                        <div className="prajitura-popup-small"></div>
                        <div className="configurator">
                            <span onClick={closeConfigurator} className="close-icon" data-qa="prajitura-close-configurator-btn">&times;</span>
                            <div className="title"><p><FormattedMessage id="StoragePreferences"/></p></div>
                            <div className="row">
                                <button onClick={acceptAllCookies} className="accept-all-cookies-btn" data-qa="prajitura-configurator-accept-all-btn"><FormattedMessage id="AcceptAll"/>
                                </button>
                            </div>
                            <div className="row">
                                <label><FormattedMessage id="StrictlyNecessaryCookies"/></label>
                                <div className="zonizSwitch labeled disabled" id="strictly_necessary_cookies">
                                    <input type="hidden"
                                           tabIndex="-1"
                                           aria-hidden="true"
                                    />
                                    <div className="labels">
                                        <div className="dot"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label><FormattedMessage id="StatisticsCookies"/></label>
                                <div onClick={toggleSwitch}
                                     className={state.configuratorSwitch === true ? "zonizSwitch labeled on" : "zonizSwitch labeled off"}
                                     id="statistics_cookies"
                                     data-qa="prajitura-toggle-statistics-switch">
                                    <input type="hidden" tabIndex="-1"
                                           aria-hidden="true"
                                    />
                                    <div className="labels">
                                        <div className="dot"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <button onClick={savePreferences}
                                        id="savePreferencesBtn"
                                        className="cc-close neutral-btn"
                                        data-qa="prajitura-configurator-save-pref-btn"><FormattedMessage id="SavePreferences"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
                : null
            }

        </>


    );

}


export default CookiesBanner;
